<div class="gauge-container">
  @if (isLoading) {
  <!-- @if (true) { -->
    <div class="loading-state">
      <div class="loading-circle"></div>
      <div class="loading-text">
        <span class="loading-percentage"></span>
        <span class="loading-inner-text"></span>
      </div>
    </div>
  }

  @else {
    <svg class="gauge" viewBox="0 0 36 36">
    <!-- unfilled outer-circle -->
    <circle class="gauge-background" cx="18" cy="18" r="16" />
    <!-- filled outer-circle -->
    <circle
      class="gauge-foreground"
      cx="18"
      cy="18"
      r="16"
      [attr.stroke-dasharray]="circumference"
      [attr.stroke-dashoffset]="offset"
      [attr.stroke]="progressBarColorString"
    />
    <!-- inner-circle -->
    <g class="circles-and-ticks">
      @for (element of innerCircleElements; track $index) {
      <!-- 0 => tick -->
      @if (element.type === 0) {
      <line
        [attr.x1]="element.x1"
        [attr.x2]="element.x2"
        [attr.y1]="element.y1"
        [attr.y2]="element.y2"
        [class.filled]="element.isFilled"
        [attr.stroke]="element.isFilled ? progressBarColorString : '#ccc'"
      />
      } @else if(element.type === 1) {
      <!-- 1 => circle -->
      <circle
        [attr.cx]="element.cx"
        [attr.cy]="element.cy"
        [class.filled]="element.isFilled"
        [attr.stroke]="element.isFilled ? progressBarColorString : '#ccc'"
        [attr.fill]="element.isFilled ? progressBarColorString : '#ccc'"
        r="0.4"
      />
      } }
    </g>
  </svg>

  <div class="gauge-text">
    <span class="percentage">{{ valueForPresentation }}%</span>
    <span class="inner-text">{{innerText}}</span>
  </div>
}
  
</div>
